import React, { useState, useEffect, forwardRef } from 'react';

// convertFormat=false opts out of the .webp probe — for slides whose
// source CDN we don't control (monarch, entertainment, peacock, nova,
// broadsign), the .webp variant is guaranteed to 404 and the wasted
// round-trip per asset hits upstream hard.
const Img = forwardRef(({ src, alt, onError, convertFormat = true, ...props }, ref) => {
	const [useFallback, setUseFallback] = useState(false);

	useEffect(() => {
		setUseFallback(false);
	}, [src]);

	const handleError = (e) => {
		if (convertFormat && !useFallback && src) {
			setUseFallback(true);
		} else if (onError) {
			onError(e);
		}
	};

	const resolvedSrc = convertFormat && src && !useFallback
		? src.replace(/\.\w+(?=[?#]|$)/, '.webp')
		: src;

	return <img ref={ref} src={resolvedSrc} alt={alt} onError={handleError} {...props} />;
});

export default Img;
